import React from 'react';
import { useExternalCompany } from 'src/hooks/use-external-company';
import useMember from 'src/hooks/use-member';
import CompanyInformationAboutTab from '../../components/company/company-tabs/CompanyInformationAboutTab';
import CompanyInformationEconomyTab from '../../components/company/company-tabs/CompanyInformationEconomyTab';
import CompanyInformationRegistreTab from '../../components/company/company-tabs/CompanyInformationRegistreTab';
import { useTranslation } from 'react-i18next';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import CompanyInformationApplicationsTab from '../../components/company/company-tabs/CompanyApplicationsTab';
import { Tabs } from '@innovationnorway/cl-react';

type Props = {
  organizationNumber: string;
  clusterMemberId: string;
  hideNaceWarning?: boolean;
};

const tabs = ['about', 'register', 'economy', 'applications'] as const;

const CompanyInformationTabs: React.FC<Props> = ({
  clusterMemberId,
  organizationNumber,
  hideNaceWarning,
}) => {
  const { t: tSiva } = useTranslation('siva');

  const { data: externalCompany, isInitialLoading: externalCompanyLoading } =
    useExternalCompany(organizationNumber);
  const { member, isInitialLoading: memberLoading } = useMember(clusterMemberId);

  if (externalCompanyLoading || memberLoading) return <LoadingPage />;

  if (!externalCompany) return <div>Kunne ikke laste bedriftsinfo. Kontakt support om feilen vedvarer.</div>;

  return (
    <Tabs defaultValue="about">
      <Tabs.List>
        {tabs.map((tab) => (
          <Tabs.Tab key={'tab__' + tab} value={tab}>
            {tSiva(`companyTabs.tabs.${tab}`)}
          </Tabs.Tab>
        ))}
      </Tabs.List>
      <Tabs.Panel value="about">
        <CompanyInformationAboutTab
          company={externalCompany}
          member={member}
          hideNaceWarning={hideNaceWarning}
        />
      </Tabs.Panel>
      <Tabs.Panel value="register">
        <CompanyInformationRegistreTab company={externalCompany} />
      </Tabs.Panel>
      <Tabs.Panel value="economy">
        <CompanyInformationEconomyTab company={externalCompany} />
      </Tabs.Panel>
      <Tabs.Panel value="applications">
        <CompanyInformationApplicationsTab />
      </Tabs.Panel>
    </Tabs>
  );
};

export default CompanyInformationTabs;
